import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconToast"><Path d="M19.5 12.3762C20.7534 11.4443 21.5 10.2726 21.5 9C21.5 5.96243 17.2467 3.5 12 3.5C6.75329 3.5 2.5 5.96243 2.5 9C2.5 10.2726 3.24658 11.4443 4.5 12.3762V20.5H19.5V12.3762Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconToast;
